import PhoneIcon from "@mui/icons-material/Phone";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { neutral } from "app/themes/colors";

import { DialerCallerDetail } from "components/suno-dialer/types";
import useSunoDialer from "components/suno-dialer/use-suno-dialer.hook";
import { formatPhoneNumber } from "utils/common";
import CallItemState from "./call-item-state.component";
import Tooltip from "@mui/material/Tooltip";

type CallQueueItemProps = {
  item: DialerCallerDetail;
};

export default function CallQueueItem({ item }: CallQueueItemProps) {
  const { activeCall, incomingCall, canSwapCurrentCall, handleSwapCall } =
    useSunoDialer();

  const { extra = null, state = undefined } = item ?? {};

  const isCurrent = activeCall
    ? activeCall?.id === item.id
    : incomingCall && incomingCall?.id === item.id;

  const displayName = extra?.full_name
    ? extra?.full_name
    : extra?.phone_number
    ? `${formatPhoneNumber(String(extra?.phone_number))} (Unknown Caller)`
    : "Unknown Caller";

  return (
    <Tooltip
      disableInteractive
      title={canSwapCurrentCall ? "Click to swith to this call" : ""}
    >
      <Stack
        direction="row"
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          p: 0.75,
          boxSizing: "border-box",
          borderRadius: "8px",
          color: isCurrent ? "black" : "white",
          background: isCurrent ? "hsla(154, 32%, 62%, 1)" : undefined,
          "&:hover": {
            background: isCurrent
              ? undefined
              : canSwapCurrentCall
              ? neutral[800]
              : undefined,
            cursor:
              canSwapCurrentCall && !isCurrent ? "pointer" : "not-allowed",
          },
        }}
        onClick={(event) => {
          event.stopPropagation();
          if (canSwapCurrentCall && !isCurrent) {
            handleSwapCall(item.id);
          }
        }}
      >
        <Stack direction="row" alignItems="center" height="100%">
          <PhoneIcon
            sx={{
              fontSize: "16px",
              p: "2px",
              border: `solid 1px ${isCurrent ? "black" : "white"}`,
              borderRadius: "50%",
              mr: 1,
              color: isCurrent ? "black" : "white",
            }}
          />
          <Typography
            sx={{
              fontSize: "13px",
              lineHeight: 1.1,
            }}
          >
            {displayName}
            {extra?.segment ? ` (${extra.segment})` : ""}
          </Typography>
        </Stack>
        <CallItemState state={state} />
      </Stack>
    </Tooltip>
  );
}
